import type { ComponentType } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import { Redirect } from '../../router/react-router-v5-compat';
import i18n from '../../i18n';
import JobSettingsPage from './job-settings.page';
import PermissionSettingsPage from './permission-settings.page';
import './scss/employee-management.page.scss';
import { HookDecorator } from '../main/main-page-states';

const EMPLOYEE_MANAGEMENT_BASE = '/main/rbp-cloud/employee-management';

const TAB_DEFS: {
    path: string;
    i18nKey: string;
    Component: ComponentType;
}[] = [
    { path: `${EMPLOYEE_MANAGEMENT_BASE}/job`, i18nKey: 'employee_management_tab_job_settings', Component: JobSettingsPage },
    { path: `${EMPLOYEE_MANAGEMENT_BASE}/permission`, i18nKey: 'employee_management_tab_permission_settings', Component: PermissionSettingsPage },
];

const DEFAULT_TAB_PATH = TAB_DEFS[0].path;

/**
 * 云 RBP「员工管理」壳页：顶部 Tab 切换「岗位设置」「权限设置」（与「我的餐厅」同构）
 */
export default HookDecorator(() => {
    const history = useHistory();
    const { pathname } = useLocation();

    if (pathname === EMPLOYEE_MANAGEMENT_BASE || pathname === `${EMPLOYEE_MANAGEMENT_BASE}/`) {
        return <Redirect to={DEFAULT_TAB_PATH} />;
    }
    const active = TAB_DEFS.find((t) => t.path === pathname);
    if (!active) {
        return <Redirect to={DEFAULT_TAB_PATH} />;
    }

    const { Component } = active;

    return (
        <Box className="employee-management-page">
            <Tabs
                className="employee-management-page__tabs"
                value={pathname}
                onChange={(_, value: string) => history.push(value)}
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{ style: { display: 'none' } }}
            >
                {TAB_DEFS.map((t) => (
                    <Tab
                        key={t.path}
                        value={t.path}
                        disableRipple
                        label={i18n.t(t.i18nKey)}
                        className="employee-management-page__tab"
                    />
                ))}
            </Tabs>
            <Box className="employee-management-page__panel">
                <Component />
            </Box>
        </Box>
    );
});
